import { z } from 'zod';

import { externalEvaluationSourceSchema } from './judges';

export const dailyJudgeBreakdownSchema = z.object({
	judgeId: z.string(),
	judgeName: z.string(),
	total: z.number().int().nonnegative(),
	passing: z.number().int().nonnegative(),
});
export type DailyJudgeBreakdown = z.infer<typeof dailyJudgeBreakdownSchema>;

export const dailySourceBreakdownSchema = z.object({
	source: externalEvaluationSourceSchema,
	total: z.number().int().nonnegative(),
	passing: z.number().int().nonnegative(),
	average: z.number().nullable().optional(),
});
export type DailySourceBreakdown = z.infer<typeof dailySourceBreakdownSchema>;

export const dailyReportConsolidatedSummarySchema = z.object({
	summary: z.string(),
	wentWell: z.array(z.string()).default([]),
	needsReview: z.array(z.string()).default([]),
	recommendedActions: z.array(z.string()).default([]),
});
export type DailyReportConsolidatedSummary = z.infer<typeof dailyReportConsolidatedSummarySchema>;

export const dailyModuleReportSchema = z.object({
	moduleName: z.string(),
	day: z.string(),
	llmTotal: z.number().int().nonnegative(),
	llmPassing: z.number().int().nonnegative(),
	llmScore: z.number().nullable().optional(),
	byJudge: z.array(dailyJudgeBreakdownSchema),
	externalTotal: z.number().int().nonnegative(),
	externalPassing: z.number().int().nonnegative(),
	externalScore: z.number().nullable().optional(),
	externalAverage: z.number().nullable().optional(),
	externalDistribution: z.record(z.number().int().nonnegative()),
	bySource: z.array(dailySourceBreakdownSchema),
	conversationsTotal: z.number().int().nonnegative().default(0),
	handoffTotal: z.number().int().nonnegative().default(0),
	closedTotal: z.number().int().nonnegative().default(0),
	generatedAt: z.string().nullable().optional(),
	consolidatedSummary: dailyReportConsolidatedSummarySchema.nullable().optional(),
});
export type DailyModuleReport = z.infer<typeof dailyModuleReportSchema>;

export const dailyReportsResponseSchema = z.object({
	items: z.array(dailyModuleReportSchema),
});
export type DailyReportsResponse = z.infer<typeof dailyReportsResponseSchema>;
